import type { Rosters } from './types/roster';
import axios from 'axios';
import { getRostersMock } from './mock/rosters.mock';
import { isDev } from '../util/isDev';

export async function fetchUserRosters(
  authorization: string,
  startDate?: string,
  endDate?: string
): Promise<Rosters> {
  if (isDev()) {
    return [getRostersMock()[0]];
  }

  const rosterURL =
    startDate && endDate
      ? `/api/v1/my/roster/${startDate}/${endDate}`
      : '/api/v1/my/roster';

  const response = await axios.get(rosterURL, {
    headers: {
      Authorization: authorization,
    },
  });

  return response?.data;
}
